var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"katakana"},[_c('stop-watch',{ref:"stopwatch"}),_vm._v(" "),_c('kana-chart',{attrs:{"character-set":"katakana","kana":_vm.orderedKana},on:{"first-kana-selection":_vm.onFirstKanaSelection,"kana-selected":_vm.onKanaChartSelected}}),_vm._v(" "),_c('randomized-kana',{attrs:{"character-set":"romaji","kana":_vm.randomizedKana},on:{"kana-selected":_vm.onRandomKanaSelected}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624d6046","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Katakana.vue
// module id = null
// module chunks = 